import moment from "moment";

export function formatSystemMessage(rawMessage: string): string {
  // Extract timestamp from pattern {[TIMESTAMP- <date>]}
  const match = rawMessage.match(/\{\[TIMESTAMP-\s*([^\]]+)\]}/);
  if (!match) return rawMessage; // no timestamp found

  const rawTimestamp = match[1].trim(); // e.g., "10/16/2025 06:26:37"

  // Parse the UTC timestamp using moment
  const utcMoment = moment.utc(rawTimestamp); // treat as UTC
  if (!utcMoment.isValid()) return rawMessage; // invalid date fallback

  // Convert to local timezone
  const localTime = utcMoment.local();

  // Format the date
  const formattedTime = localTime.format("ddd, MMM DD, hh:mm A"); // e.g., "Thu, Oct 16, 06:26 AM"

  // Remove the timestamp placeholder and append formatted time
  const messageWithoutTimestamp = rawMessage.replace(/\s*-\s*\{\[TIMESTAMP-[^\]]+\]}/, "");
  return `${messageWithoutTimestamp} · ${formattedTime}`;
}
